export default function buildPostInquiryConfirm({
    apiEndpoint,
    apiTools
}) {
    return async function postInquiryConfirm(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/inquiry/confirm`
        })
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
            body: args.body
        });
        return await res.json();
    }
}